<template>
    <b-row>
        <b-col>
            <b-row class="mb-3">
                <div class="dropbox">
                    <input :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" class="input-file" id="files" type="file" multiple ref="files">
                    <md-icon v-if="isSaving">add</md-icon>

                    <div v-else class="dropbox-desc">
                        <p>Add Files <i class="el-icon-plus add-icon"></i></p>
                        <i>Drag your files here or click</i>
                    </div>
                </div>
            </b-row>
            <md-chip color="#2C8C87" text-color="white" v-for="(file) in tempFileHolders" :key=file.name>{{file.name}}</md-chip>

            <b-row v-if="uploadingFile" row class="mt-5">
              <md-progress-spinner  :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
            </b-row>
            <b-row v-else row class="mt-5">
                <md-button class="play-cta-button-flat grey" @click="clearUploadFiles()" :disabled="tempFileHolders.length == 0 || uploadingFile">Clear</md-button>
                <md-button class="play-cta-button navy" @click="uploadFiles()" :disabled="tempFileHolders.length == 0">Upload</md-button>
            </b-row>
        </b-col>

        <md-snackbar :md-active.sync="showSnackbar" md-persistent>
            <span>{{snackbarText}}</span>
        </md-snackbar>

    </b-row>
</template>

<script>
  import { uploadUserFiles, allowedFileMimeType } from '../../platform/files/services/fileService'

  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
  const MAX_FILE_MB = 2
  export default {
    props: {
      startWithFiles: Array
    },
    data() {
      return {
        uploadingFile: false,
        buffer: 100,
        showSnackbar: false,
        snackbarText:"",
        fileCount: 0,
        tempFileHolders: [],
        fileCounterGlobal: -1,
        processedThumbsCounterGlobal: 0,
        currentStatus: STATUS_INITIAL,
        files:[],
        uploadedFiles:''
      };
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        if(this.currentStatus === STATUS_SAVING){
          return true
        }
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
    },
    mounted(){
    },
    created(){
      if(this.startWithFiles && this.startWithFiles.length > 0){
        for (var file of this.startWithFiles) {
          this.fileCounterGlobal++
          var temp = {
            progress: 100,
            id: this.fileCounterGlobal,
            name: file.name
          }
          this.tempFileHolders.push(temp)
        }
        this.processedThumbsCounterGlobal = this.tempFileHolders.length
      }
    },
    methods: {
        uploadFiles(){
            this.uploadingFile=true
            let formData = new FormData();
            for( var i = 0; i < this.files.length; i++ ){
                let file = this.files[i];
                formData.append("file"+i, file);
            }
            uploadUserFiles(formData)
              .then(responseData => {
                  this.$emit("uploadedFileNames", responseData.result)
                  this.uploadingFile=false
              })
              .catch(err => {
                  console.log('uploadFiles | err:', err);
                  this.uploadingFile=false
              });  
        },
        clearUploadFiles(){
            document.getElementById('files').value = "";
            this.files=[]
            this.tempFileHolders=[]
        },
        removeFile(index){
            this.files.splice( index, 1 );
            this.tempFileHolders.splice(index, 1)
        },
        filesAreAllowed(files){
          var result = {success: false, message: ""}
          for (var i = 0; i < files.length; i++) {
            result = this.allowedMime(files[i])
            if(!result.success) return result

            result = this.allowedSize(files[i])
            if(!result.success) return result            
          }
          return result
        },
      allowedSize(file){
        if(file.size/1000000 > MAX_FILE_MB) return {success:false, message: "File too large, " + "max " + MAX_FILE_MB + "Mb allowed"}
        else return {success:true, message: ""}
      },
      allowedMime(file){
        if(allowedFileMimeType(file)) return {success:true, message: ""}
        else return {success:false, message: "File type not allowed"}
      },
      filesChange(fieldName, fileList) {
        try{
          var i;
          var sourceFiles = []
          var count = fileList.length
          var fileCheckReport = this.filesAreAllowed(fileList)
          if(fileCheckReport.success){
            let uploadedFiles = this.$refs.files.files;
            for( var i = 0; i < uploadedFiles.length; i++ ){
                this.files.push( uploadedFiles[i] );
            }
            // TODO: fix this stupid shit here
            for (i = 0; i < fileList.length; i++) {
                this.tempFileHolders.push(fileList[i])
            }
          }else{
            this.notifyUser(fileCheckReport.message)
          }
        }catch(err){
            console.log(err)
        }
      },
      notifyUser(msg){
          this.showSnackbar = true
          this.snackbarText = msg
      }
    }
  }
</script>
<style scoped>
  @import '../../assets/styles/global.css';

 .add-icon{
    color: #506993;
    text-align: center;
  }

  .dropbox {
    outline: 2px dashed grey;
    color: dimgray;
    display: table;
    width: 100%;
    position: relative;
  }
  .image-preview-container{
    background-color: #eaeaea80;
  }

  .dropbox-desc{
    vertical-align: middle;
    display: table-cell;
    text-align: center;
    height: 100%;
    padding: 1em;
  }
  .dropbox-desc p{
    margin-bottom:0;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
  .img-working-cover{
    width: 100%;
    height: 100%;
    position: absolute;
    color: grey;
    background-color: rgb(0,0,0,0.6);
    color: white;
    text-align: center;
    padding-top: 60px;
  }
  .show-when-parent-hover {
    opacity: 0;
    position: absolute;
    cursor: pointer;
    width: 55px;
    height: 55px;
    top: 25%;
    left: 38%;
  }

  .image-preview-container:hover .show-when-parent-hover{
    opacity: 1;
  }

  .image-preview-container:hover .photo-add-holder{
    opacity: 0.2
  }
  .img-upload-progress-bar{
  	height: 10%;
  	font-size: 0.75rem;
  	background-color: #e9ecef;
  	margin-left: 1em;
  	margin-right: 1em;
  	position: relative;
  	top: 45%;
  }



  .photo-add-holder {
    cursor: pointer;
  }

  .photo-add-holder li.el-upload-list{
    min-width: 244px;
    min-height: 156px;
  }

  .photo-uploded{
    padding: 15px;
  }
  #skip-add-img-btn{
    width: 100%;
    background: lightgrey;
    border:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/files/multiFileUploader.vue